module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("5")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("Ich bitte")]), _vm._v(" nur um ein\nwenig Geduld,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\num an deiner Seite zu sitzen, das Werk,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndas ich wirke, wird später vollendet.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Ferne dem Schaun auf dein Antlitz,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nkennt mir das Herz nicht Ruhe noch Rast;"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nund mein Werk wird endloses Mühn"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nam uferlosen Meere der Mühe.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Heut kam der Sommer ans Fenster"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nmit seinem Summen und Surren, die"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nBienen singen von Minne am Hofe des"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nblühenden Haines.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Nun ist es Zeit, um stille zu sitzen von"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nAntlitz zu Antlitz mit dir und dir zu singen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndes Lebens Widmung in dieser schweigenden,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nüberströmenden Muße. "), _c('a', {
    attrs: {
      "id": "page8",
      "title": "wedi/cal"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c71e0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0006.vue
// module id = 72
// module chunks = 0